import React, { CSSProperties, FC } from 'react';
import styled from '@emotion/styled';
import { useHistory } from 'react-router';
import { useButton, useI18n } from '~Hooks';
import Icon from '~ComponentsImproved/Icon';
import BackIcon from '~Assets/icons/arrow_back.svg';
import ErrorCircleIcon from '~Assets/icons/error-circle.svg';
import { BackButton } from '~ComponentsImproved/BackTopBar';

interface Props {
  venueId: string;
  /** The venue theme as CSS variables, kept in sync with the loader it replaces. */
  themeVars: CSSProperties;
}

const Wrapper = styled.div`
  height: 100vh;
  width: 100vw;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: var(--eposFontFamily);
  background: var(--eposPrimary);
`;

const TopBar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  padding: 16px;
`;

/** Own text rather than BackTopBar's Title, which has a fixed color. */
const BackTitle = styled.span`
  margin-left: 8px;
  font-size: 20px;
  font-weight: 600;
  color: var(--eposAccent);
`;

const Headline = styled.h1`
  margin: 16px 0 0;
  font-size: 40px;
  font-weight: 800;
  color: var(--eposAccent);
`;

const Description = styled.p`
  margin: 8px 0 0;
  font-size: 20px;
  color: var(--eposAccent);
  opacity: 0.7;
`;

/** Shown when the menu data could not be fetched - same theme as the loader. */
const NoData: FC<Props> = ({ venueId, themeVars }) => {
  const { i18n } = useI18n();
  const history = useHistory();

  const backButton = useButton({
    onClick: () => history.push(`/venue/${venueId}`),
  });

  return (
    <Wrapper style={themeVars}>
      <TopBar>
        <BackButton {...backButton}>
          <Icon src={BackIcon} color="var(--eposAccent)" />
        </BackButton>
        <BackTitle>{i18n('SSK.Return')}</BackTitle>
      </TopBar>

      <Icon height="120px" width="120px" src={ErrorCircleIcon} color="var(--colorUIRed)" />

      <Headline>{i18n('SSK.NoData')}</Headline>
      <Description>{i18n('SSK.NoData.Desc')}</Description>
    </Wrapper>
  );
};

export default NoData;
